import React from 'react';
import * as S from './styles';

export interface FormFeedbackProps {
  children?: React.ReactNode;
}

/**
 * Placed between form elements to communicate general feedback/errors to the user.
 * For example, some form errors might not correspond to a single field, making it
 * difficult to display the error as an input error.
 */
const FormFeedback: React.FC<FormFeedbackProps> = ({ children }) => (
  <S.Root>{children}</S.Root>
);

export default FormFeedback;
